import { render } from "./PaperBoat.vue?vue&type=template&id=9b2bc91c&scoped=true"
import script from "./PaperBoat.vue?vue&type=script&lang=js"
export * from "./PaperBoat.vue?vue&type=script&lang=js"

import "./PaperBoat.vue?vue&type=style&index=0&id=9b2bc91c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b2bc91c"]])

export default __exports__